import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTabsModule } from '@angular/material/tabs'
import { TranslateModule } from '@ngx-translate/core'
import { NgxPaginationModule } from 'ngx-pagination'

import { PipeModule } from '../../pipes/pipe.module'
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module'
import { ProjectModule } from '../project/project.module'
import { RecommendModule } from '../recommend/recommend.module'
import { AddCartComponent } from './add-cart/add-cart.component'
import { AdvantageComponent } from './advantage/advantage.component'
import { DialogAddCartComponent } from './dialog-add-cart/dialog-add-cart.component'
import { MarketRoutingModule } from './market-routing.module'
import { MarketplaceComponent } from './marketplace/marketplace.component'
import { ProductDetailComponent } from './product-detail/product-detail.component'
import { ProductListItemComponent } from './product-list-item/product-list-item.component'
import {
  ProductResourceBarComponent,
  ProductResourceBarInstallMediaResponseComponent,
} from './product-resource-bar/product-resource-bar.component'
import { PageLoaderModule } from '../layout/page-loader/page-loader.module'

@NgModule({
  declarations: [
    MarketplaceComponent,
    ProductListItemComponent,
    ProductDetailComponent,
    ProductResourceBarComponent,
    ProductResourceBarInstallMediaResponseComponent,
    AddCartComponent,
    DialogAddCartComponent,
    AdvantageComponent,
  ],
  imports: [
    CommonModule,
    RecommendModule,
    MarketRoutingModule,
    PipeModule,
    BreadcrumbModule,
    ProjectModule,
    MatCardModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatListModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    NgxPaginationModule,
    TranslateModule.forChild(),
    PageLoaderModule,
  ],
  exports: [
    ProductResourceBarComponent,
    ProductResourceBarInstallMediaResponseComponent,
    AdvantageComponent,
  ],
})
export class MarketModule {}
